import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useSearch } from "@tanstack/react-router";
import { z } from "zod";
import { useEffect } from "react";
import { supabase } from "@/ajax/clients/supabase";
import { Session } from "@supabase/supabase-js";

const searchSchema = z.object({
  l: z.string().regex(/^\//, "Invalid redirect URL - must be a valid path"),
});

const SignInLinkPage = () => {
  const { l: link } = useSearch({ strict: false });
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (event: string, session: Session | null) => {
      if (event === "SIGNED_IN" && session) {
        navigate({ to: link });
      }
    };
    const subscription = supabase.auth.onAuthStateChange(handler);
    return () => {
      subscription.data.subscription.unsubscribe();
    };
  }, [navigate, link]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-linear-to-b from-white to-gray-50">
      <div className="max-w-md w-full space-y-8">
        <div className="flex flex-col items-center">
          <img
            src="/static/images/logo.png"
            alt="Saile Logo"
            className="h-12 mb-8"
          />
          <div className="bg-white p-8 rounded-2xl shadow-xs border border-gray-100 space-y-6 w-full">
            <div className="space-y-4 text-center">
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
              </div>
              <h1 className="text-3xl font-bold text-gray-900">
                Logging you in...
              </h1>
              <p className="text-gray-600">
                Please wait while we securely log you into Saile
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const Route = createFileRoute("/auth/signin/redirect/")({
  component: SignInLinkPage,
  validateSearch: searchSchema,
});
